import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ObjViewerComponent } from './obj-viewer.component';

@NgModule({
    declarations: [
        ObjViewerComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        ObjViewerComponent
    ]
})
export class NcObjViewerModule { }